import {
  Box, Button, Card, IconButton, Typography, useTheme, useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid2 from "@mui/material/Grid2";
import { useDispatch, useSelector } from "react-redux";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { format_Number } from "../../utils/utils";
import { setCombinationQTY, setSelectedCombination } from "../../store/slice/Activity.slice";
import CardSection from "./CardSection";
import ExpandLessTwoToneIcon from "@mui/icons-material/ExpandLessTwoTone";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const isSameItem = (a, b) =>
  a.idreservationtype === b.idreservationtype &&
  a.arrivalTime === b.arrivalTime &&
  a.depatureTime === b.depatureTime &&
  a.isBefore === b.isBefore;

const isItemSelected = (selectedCombination, item) =>
  selectedCombination?.some((prod) => isSameItem(prod, item));

const Combination = ({
  steps, activeStep, handleBack, handleNextFunc, errors, isLoading,
  languageId, widgetType, totalCount, languageWords, reservType, selectedDate,
  adult, child, kid, baby, toddler, selectedExtraProduct, time,
  transactionDetails, transactionPrice, excludingVat, totalVat, totalIncludingVAT,
  totalCostYourBooking, setUpsaleCombination, combinationUpsale, total_product_price,
}) => {
  const { css } = useSelector((store) => store?.widgetSettings);
  const Css = css?.find((item) => item?.cssTabFieldsGroupName === "Combinations")?.fields;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);
  const [isImageError, setIsImageError] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const dispatch = useDispatch();
  const { selectedCombination, combinationQTY, combinationList, AvailableLocationData } =
    useSelector((store) => store.Activity);
  const [isShowMore, setIsShowMore] = useState(false);
  const productsToDisplay = combinationList?.length > 0
    ? isShowMore ? combinationList : combinationList?.slice(0, 2)
    : [];
  const { widgetConfig, resType } = useSelector((store) => store?.widgetSettings);

  useEffect(() => {
    if (Object.keys(combinationQTY).length > 0) return;
    const obj = combinationList?.reduce((acc, red) => {
      const key = red.idreservationtype + String(red.isBefore);
      if (red.activitiesPriceType === "priceperperson") {
        acc[key] = totalCount;
      } else if (red.activitiesPriceType === "pricepertime") {
        let needed = totalCount, usedTables = 0;
        const sortedTables = [...(red.tables || [])].sort((a, b) => b.seats - a.seats);
        for (let table of sortedTables) {
          if (table.seats && table.seats > 0) { needed -= table.seats; usedTables++; if (needed <= 0) break; }
        }
        acc[key] = usedTables;
      } else { acc[key] = totalCount; }
      return acc;
    }, {});
    dispatch(setCombinationQTY(obj));
  }, [combinationList, totalCount]);

  const handleIncrement = (e, item) => {
    e.stopPropagation();
    setIsAdd(true);
    const key = item?.idreservationtype + String(item.isBefore);
    const maxCount = item?.activitiesPriceType === "priceperperson" ? totalCount : item?.tableCount;
    if (!isItemSelected(selectedCombination, item)) {
      if (selectedCombination.length >= 2) return;
      dispatch(setSelectedCombination([...selectedCombination, item]));
    }
    if (combinationQTY[key] >= (item?.mainModuleType === "Entree" ? item?.ticketingMaxGuest : maxCount)) return;
    dispatch(setCombinationQTY((prev) => ({ ...prev, [key]: (prev[key] || 0) + 1 })));
  };

  const handleDecrement = (e, item) => {
    e.stopPropagation();
    const key = item?.idreservationtype + String(item.isBefore);
    if (!combinationQTY[key]) return;
    if (combinationQTY[key] <= 1) { handleRemoveCombination(item); return; }
    dispatch(setCombinationQTY((prev) => ({ ...prev, [key]: prev[key] - 1 })));
  };

  function convertToMinutes(time) {
    if (!time) return 0;
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }

  const handleAddCombination = (item) => {
    setIsAdd(true);
    const key = item?.idreservationtype + String(item.isBefore);
    if (isItemSelected(selectedCombination, item) || selectedCombination.length >= 2) return;
    dispatch(setSelectedCombination([...selectedCombination, item]));
    dispatch(setCombinationQTY((prev) => ({ ...prev, [key]: prev[key] || totalCount })));
  };

  const handleRemoveCombination = (item) => {
    setIsAdd(false);
    dispatch(setSelectedCombination(selectedCombination.filter((prod) => !isSameItem(prod, item))));
    const obj = combinationList?.reduce((acc, red) => {
      const k = red.idreservationtype + String(red.isBefore);
      if (red.activitiesPriceType === "priceperperson") { acc[k] = totalCount; }
      else if (red.activitiesPriceType === "pricepertime") {
        let needed = totalCount, usedTables = 0;
        const sortedTables = [...(red.tables || [])].sort((a, b) => b.seats - a.seats);
        for (let table of sortedTables) {
          if (table.seats && table.seats > 0) { needed -= table.seats; usedTables++; if (needed <= 0) break; }
        }
        acc[k] = usedTables;
      } else { acc[k] = totalCount; }
      return acc;
    }, {});
    dispatch(setCombinationQTY(obj));
  };

  const handleCardClick = (item) => {
    if (isItemSelected(selectedCombination, item)) handleRemoveCombination(item);
    else handleAddCombination(item);
  };

  useEffect(() => {
    const combination_upsale = selectedCombination?.flatMap((item) =>
      item?.upsaleProducts?.map((product) => ({
        ...product, isBefore: item.isBefore,
        idreservationtype: item.idreservationtype, reservationType: item.reservationType,
      }))
    );
    dispatch(setUpsaleCombination(combination_upsale));
  }, [selectedCombination]);

  return (
    <Box sx={{ p: { xs: 1, sm: 1.5, md: 2 } }}> 
      <Grid2 container spacing={2}>
        <Grid2 size={{ md: 9, sm: 12, xs: 12 }}>
          {!loading && (
            <>
              <Box sx={{ mb: { xs: 1, sm: 2 } }}>
                <Typography sx={{
                  color: Css?.combinationsHeadingClr,
                  fontSize: { xs: "14px", sm: "16px", md: "20px" }, 
                }}>
                  {languageWords?.Bowling}
                </Typography>
                <Typography sx={{
                  fontSize: { xs: "11px", sm: "12px" },
                  color: Css?.CombinationdHeadingInfoClr,
                  mt: 1, mb: 1,
                }}>
                  {languageWords?.CombinationInfo}
                </Typography>
              </Box>

              {productsToDisplay?.map((item, index) => {
                const selected = isItemSelected(selectedCombination, item);
                const isDisabled = selectedCombination?.some((sel) => {
                  if (isSameItem(sel, item)) return false;
                  const selArrival = convertToMinutes(sel.arrivalTime);
                  const selDeparture = convertToMinutes(sel.depatureTime);
                  const itemArrival = convertToMinutes(item.arrivalTime);
                  const itemDeparture = convertToMinutes(item.depatureTime);
                  return (
                    (itemArrival >= selArrival && itemArrival < selDeparture) ||
                    (itemDeparture > selArrival && itemDeparture <= selDeparture) ||
                    (itemArrival <= selArrival && itemDeparture >= selDeparture)
                  );
                });

                return (
                  <Grid2
                    container alignItems="center"
                    key={item?.idreservationtype + String(item?.isBefore) + index}
                    onClick={() => handleCardClick(item)}
                    sx={{
                      display: isDisabled ? "none" : "flex",
                      position: "relative",
                      border: "1px solid #EBEBEB",
                      borderRadius: "5px",
                      backgroundColor: selected ? Css?.CombinationsItemActiveBgClr : Css?.CombinationsItemBgClr,
                      mb: { xs: 1, sm: 2 },
                      width: "100%",
                      opacity: isDisabled ? 0.5 : 1,
                      pointerEvents: isDisabled ? "none" : "auto",
                      cursor: "pointer",
                    }}
                  >
                    {item?.imageFilePath && !isImageError && (
                      <Grid2 size={{ md: 2, sm: 2, xs: 12 }}
                        sx={{ width: "100%", height: "100%", overflow: "hidden", p: 1 }}>
                        <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", overflow: "hidden" }}>
                          <img src={item.imageFilePath} alt="extra-img"
                            onLoad={() => setIsImageError(false)} onError={() => setIsImageError(true)}
                            style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                        </Box>
                      </Grid2>
                    )}

                    <Grid2
                      size={{ md: item?.imageFilePath && !isImageError ? 10 : 12, sm: item?.imageFilePath && !isImageError ? 10 : 12, xs: 12 }}
                      sx={{ p: { xs: 1, sm: 1.5 } }}
                      alignItems="center"
                    >
                      {/* ── Title + Add Button ── */}
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                        <Typography sx={{
                          color: selected ? Css?.CombinationsItemActiveHeadingClr : Css?.CombinationsItemHeadingClr,
                          fontSize: { xs: "13px", sm: "14px", md: "1.1rem" }, 
                          fontWeight: "semiBold",
                          flex: 1, mr: 1,
                        }}>
                          {item?.reservationType}
                          <small style={{
                            color: selected ? Css?.CombinationsItemActiveAfterOrBeforeTextClr : Css?.CombinationsItemAfterOrBeforeTextClr,
                            fontSize: "11px", marginLeft: "0.4rem",
                          }}>
                            {item?.isBefore
                              ? `${languageWords?.before || "Before"} ${reservType?.name}`
                              : `${languageWords?.after || "After"} ${reservType?.name}`}
                          </small>
                        </Typography>

                        <Box sx={{ display: "flex", alignItems: "center" }} onClick={(e) => e.stopPropagation()}>
                          <Button
                            variant="outlined"
                            onClick={() => handleCardClick(item)}
                            sx={{
                              position: "relative",
                              borderRadius: "10px",
                              padding: { xs: "6px 12px", sm: "6px 12px", md: "8px 16px" }, 
                              minWidth: { xs: "95px", sm: "90px", md: "120px" },           
                              borderColor: selected ? Css?.ButtonActiveBorderClr : Css?.ButtonBorderClr,
                              textTransform: "none",
                              display: "flex", flexDirection: "column", lineHeight: 1.2,
                              flexShrink: 0,
                              "&:hover": { borderColor: "#bdbdbd" },
                            }}
                          >
                            <Typography sx={{
                              fontSize: { xs: "11px", sm: "12px", md: "14px" }, 
                              fontWeight: 500,
                              color: selected ? Css?.ButtonActiveTxtClr : Css?.ButtonTextClr,
                            }}>
                              {languageWords?.Add}
                            </Typography>

                            {resType === "horeca" && item?.mainModuleType === "Horeca" ? (
                              <Typography sx={{ fontSize: { xs: "11px", sm: "12px", md: "13px" }, color: "#7a7a7a" }}>
                                €{format_Number(adult * item?.fieldPrice1 + child * item?.fieldPrice2 + kid * item?.fieldPrice3 + baby * item?.fieldPrice4 + toddler * item?.fieldPrice5 || 0)}
                              </Typography>
                            ) : item?.price > 0 && (
                              <Typography sx={{
                                fontSize: { xs: "11px", sm: "12px", md: "13px" },
                                color: selected ? Css?.ButtonActiveTxtClr : Css?.ButtonTextClr,
                                fontWeight: 600,
                              }}>
                                €{format_Number(item?.price * combinationQTY[item.idreservationtype + String(item?.isBefore)])}
                              </Typography>
                            )}

                            {selected && (
                              <DeleteOutlineIcon
                                sx={{ position: "absolute", bottom: 4, right: 4, fontSize: { xs: 14, sm: 16, md: 18 }, color: "#fff", cursor: "pointer", opacity: 0.9, "&:hover": { opacity: 1 } }}
                                onClick={(e) => { e.stopPropagation(); handleRemoveCombination(item); }}
                              />
                            )}
                          </Button>
                        </Box>
                      </Box>

                      {/* ── Time Badge ── */}
                      <Box sx={{
                        display: "inline-flex", alignItems: "center",
                        border: "1px solid #dcdcdc", borderRadius: "999px",
                        padding: { xs: "2px 8px", sm: "4px 11px" }, 
                        backgroundColor: selected ? theme?.product?.bgActive : theme?.product?.bgColor,
                        minHeight: "24px", mt: 0.5,
                      }}>
                        <AccessTimeIcon sx={{ color: selected ? "#fff" : "#969BA0", fontSize: { xs: "14px", sm: "16px" } }} />
                        <Typography sx={{ fontSize: { xs: "11px", sm: "12px" }, color: selected ? "#fff" : "#7a7a7a" }}>
                          {`${item?.arrivalTime?.substring(0, 5)} - ${item?.depatureTime?.substring(0, 5)}`}
                        </Typography>
                      </Box>

                      {/* ── Description ── */}
                      <Typography sx={{
                        color: selected ? Css?.CombinationsActiveInfoClr : Css?.CombinationInfoTxtClr,
                        fontSize: { xs: "12px", sm: "13px", md: "14px" },
                        mt: 0.5, mb: 1,
                      }}>
                        {item?.reservationTypeInfo}
                      </Typography>

                      {/* ── Quantity Stepper ── */}
                      {item?.mainModuleType !== "Horeca" && (
                        <Box sx={{ display: "flex", justifyContent: "flex-end" }} onClick={(e) => e.stopPropagation()}>
                          <Box sx={{
                            display: "flex", alignItems: "center",
                            gap: { xs: "4px", sm: "8px" },
                            px: { xs: 0.5, sm: 1 }, py: 0.5,
                            borderRadius: "999px",
                            backgroundColor: selected ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.04)",
                            backdropFilter: "blur(6px)",
                          }}>
                            <Button onClick={(e) => handleDecrement(e, item)} disableRipple sx={{
                              minWidth: { xs: 28, sm: 32, md: 36 }, height: { xs: 28, sm: 32, md: 36 },
                              borderRadius: "50%", fontSize: { xs: "16px", sm: "18px", md: "20px" },
                              fontWeight: 600, color: selected ? "#fff" : "#424242",
                              backgroundColor: "transparent", transition: "all 0.25s ease",
                              "&:hover": { backgroundColor: "rgba(0,0,0,0.08)", transform: "scale(1.05)" },
                              "&:active": { transform: "scale(0.95)" },
                            }}>−</Button>

                            <Typography sx={{
                              minWidth: { xs: 20, sm: 24, md: 28 }, textAlign: "center",
                              fontSize: { xs: "12px", sm: "13px", md: "14px" }, fontWeight: 600,
                              color: selected ? "#fff" : "#424242", transition: "color 0.3s ease",
                            }}>
                              {combinationQTY[item?.idreservationtype + String(item.isBefore)] ?? 0}
                            </Typography>

                            <Button onClick={(e) => handleIncrement(e, item)} disableRipple sx={{
                              minWidth: { xs: 28, sm: 32, md: 36 }, height: { xs: 28, sm: 32, md: 36 },
                              borderRadius: "50%", fontSize: { xs: "16px", sm: "18px", md: "20px" },
                              fontWeight: 600, color: selected ? "#fff" : "#424242",
                              backgroundColor: "transparent", transition: "all 0.25s ease",
                              "&:hover": { backgroundColor: "rgba(0,0,0,0.08)", transform: "scale(1.05)" },
                              "&:active": { transform: "scale(0.95)" },
                            }}>+</Button>
                          </Box>
                        </Box>
                      )}
                    </Grid2>
                  </Grid2>
                );
              })}
            </>
          )}

          {combinationList.length > 2 && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <IconButton
                sx={{
                  backgroundColor: theme?.product?.addBtnBg, fontSize: "14px",
                  color: theme?.product?.addBtnTextColor,
                  "&:hover": { backgroundColor: theme?.product?.addBtnBgHover, color: theme?.product?.addBtnTextHover },
                }}
                onClick={() => setIsShowMore(!isShowMore)}
              >
                {!isShowMore ? <ExpandMoreTwoToneIcon /> : <ExpandLessTwoToneIcon />}
              </IconButton>
            </Box>
          )}
        </Grid2>

        <Grid2 size={{ md: 3, sm: 12, xs: 12 }} sx={{ mt: { xs: 1, sm: 2, md: 3 } }}>
          <CardSection
            steps={steps} activeStep={activeStep} handleBack={handleBack} handleNextFunc={handleNextFunc}
            errors={errors} isLoading={isLoading} languageId={languageId} totalCount={totalCount}
            languageWords={languageWords} reservType={reservType} selectedDate={selectedDate}
            adult={adult} child={child} kid={kid} baby={baby} toddler={toddler}
            selectedExtraProduct={selectedExtraProduct} time={time} transactionDetails={transactionDetails}
            selectedCombination={selectedCombination} transactionPrice={transactionPrice}
            excludingVat={excludingVat} totalVat={totalVat} totalIncludingVAT={totalIncludingVAT}
            totalCostYourBooking={totalCostYourBooking} combinationUpsale={combinationUpsale}
            total_product_price={total_product_price}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Combination;